const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class AlgoliaRecommended extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupState()
  }

  setupListeners () {
    super.setupListeners()

    document.addEventListener(
      'algolia.hooks.initialize',
      () => {
        this.registerRecommended()
      },
      { once: true },
    )
  }

  registerRecommended () {
    /* eslint-disable-next-line no-undef */
    algoliaShopify.hooks.registerHook(
      'beforeRecommendHitTemplate',
      (_defaultTemplate, html, item) => {
        const placeholderKey = [
          'algolia-product-card',
          item.objectID || item.handle,
        ].join('-')

        this.renderProductCard(item.handle, placeholderKey)

        return html`
          <div
            data-algolia-product-card-placeholder
            data-placeholder-key="${placeholderKey}"
          ></div>
        `
      },
    )
  }

  setupCarousels () {
    const recommendedCarouselEls = document.querySelectorAll(
      '.uic-HorizontalSlider-list',
    )

    if (!recommendedCarouselEls) return

    recommendedCarouselEls.forEach((recommendedCarouselEl) => {
      if (recommendedCarouselEl.classList.contains('keen-slider') === false) {
        recommendedCarouselEl.classList.toggle('keen-slider', true)

        const slideEls = recommendedCarouselEl.querySelectorAll(
          '.uic-HorizontalSlider-item',
        )
        slideEls.forEach((slideEl) => {
          slideEl.classList.toggle('keen-slider__slide', true)
        })

        // eslint-disable-next-line no-unused-vars
        const newCarousel = new KeenSlider(
          recommendedCarouselEl,
          {
            selector: '.uic-HorizontalSlider-item',
            defaultAnimation: {
              duration: 1500,
            },
            loop: false,
            mode: 'snap',
            slides: {
              perView: 'auto',
              spacing: 8,
            },
          },
          [setInitialised(), addWheelControls('horizontal')],
        )
      }
    })

    if (
      !document.body.classList.contains(
        'lyt-Theme-algoliaRecommendationsLoaded',
      )
    ) {
      document.body.classList.add('lyt-Theme-algoliaRecommendationsLoaded')
    }
  }

  async renderProductCard (productHandle, placeholderKey) {
    try {
      const productCardHtml = await this.getProductCardHtml(productHandle)
      if (!productCardHtml) return

      window.requestAnimationFrame(() => {
        const placeholder = document.querySelector(
          `[data-placeholder-key="${placeholderKey}"]`,
        )

        if (!placeholder) return

        placeholder.outerHTML = productCardHtml

        this.setupCarousels()
      })
    } catch (error) {
      this.error('productCard:renderFailed', error)
    }
  }

  async getProductCardHtml (productHandle) {
    const cachedProductCard = this.productCardCache.get(productHandle)

    if (cachedProductCard) {
      return cachedProductCard
    }

    const productUrl = [
      window.Shopify.routes.root,
      'products/',
      encodeURIComponent(productHandle),
    ].join('')

    try {
      const sectionHtml = await window.BAO.sectionRenderer.fetchSingle(
        'product-card-toggle-swatches',
        productUrl,
      )

      const sectionDocument =
        window.BAO.sectionRenderer.convertToDOM(sectionHtml)

      const articleElement = sectionDocument.querySelector('article')

      const productCardHtml = articleElement ? articleElement.outerHTML : ''

      if (productCardHtml) {
        this.productCardCache.set(productHandle, productCardHtml)
      }

      return productCardHtml
    } catch (error) {
      this.error('productCard:fetchFailed', error)

      return ''
    }
  }

  setupState () {
    this.productCardCache = new Map()
  }
}

if (!customElements.get('algolia-recommended')) {
  customElements.define('algolia-recommended', AlgoliaRecommended)
}
